import { AxiosInstance } from 'axios';
import { unreadCountParser, notificationsParser } from './utils';
import { NotificationsPoints, UnreadCount, NotificationsData } from './types';

const getNotificationsData = (api: AxiosInstance) => ({
  getNotifications: async (limit: string = '100') => {
    const { data } = await api.get<NotificationsData>(
      NotificationsPoints.GET_NOTIFICATIONS,
      {
        params: {
          limit,
        },
      },
    );
    return { ...data, data: data.data.map(notificationsParser) };
  },
});

const postNotificationData = (api: AxiosInstance) => ({
  postNotification: async (payload: string) => {
    const { data } = await api.post<any>(
      `${NotificationsPoints.POST_READED_NOTIFICATIONS}/${payload}`,
    );
    return data;
  },
});

const getNotificationsUnreadCountData = (api: AxiosInstance) => ({
  getNotificationsUnreadCount: async () => {
    const { data } = await api.get<UnreadCount>(
      NotificationsPoints.GET_UNREAD_COUNT,
    );
    return { ...unreadCountParser(data.data) };
  },
});

const notificationsService = (api: AxiosInstance) => {
  if (!api) throw new Error('There is no HTTP client');
  return {
    ...getNotificationsData(api),
    ...postNotificationData(api),
    ...getNotificationsUnreadCountData(api),
  };
};

export default notificationsService;



// WEBPACK FOOTER //
// ./src/services/notifications/notificationsService.ts